import * as d3 from 'd3';
import _ from 'lodash';
import { isTablet } from '../styles/size';

function D3Timeline(data, lineRef, timelineRef, setYear) {
  let step, year;
  let _data = data;

  const $lineContainer = d3.select(lineRef.current),
    $gAxis = $lineContainer.select('g.axis'),
    $gYAxis = $gAxis.select('g.y');

  const $timelineContainer = d3.select(timelineRef.current),
    $gXAxis = $timelineContainer.select('g.axis'),
    $clipPath = $timelineContainer.select('clipPath#clipCircle');

  const $pulse = d3.select('circle.pulse');

  const $marks = _timelineMark();
  const $img = _Img();

  let $pathcpw, $pathProjection, $circle;

  let w, h;
  _updateDimension();
  const RADIUS = 7.5,
    margin = {
      top: isTablet(w) ? 20 : 100,
      right: isTablet(w) ? 10 : 20,
      bottom: isTablet(w) ? 20 : 100,
      left: isTablet(w) ? 10 : 20,
    };

  let X, Y, line;

  _initialize();

  function _initialize() {
    _data = data.filter((d) => d.year <= new Date(2015, 1, 1));
    const minYear = d3.min(data, (d) => d.year).getFullYear();
    _updateScale([new Date(minYear - 3, 1, 1), new Date(minYear + 1, 1, 1)]);
    _updateAxisX();
    $img.show();
    $marks.append(new Date(1950, 0, 0));
    $pulse.attr('cx', X(new Date(1950, 0, 0))).attr('cy', Y(0));
  }

  function _updateDimension() {
    const parent = lineRef.current.parentElement.parentElement;

    w = parent.offsetWidth;
    h = parent.offsetHeight - (isTablet(w) ? 60 : 0);
  }

  function _updateScaleX(xDomain = d3.extent(_data, (d) => d.year)) {
    X = d3
      .scaleTime()
      .domain(xDomain)
      .range([margin.left, w - margin.right])
      .nice();
  }

  function _updateScaleY() {
    Y = d3
      .scaleLinear()
      .domain(d3.extent(_data, (d) => d.cpw))
      .range([h - margin.bottom, margin.top])
      .nice();
  }

  function _updateLine() {
    line = d3
      .line()
      .x((d) => X(d.year))
      .y((d) => Y(d.cpw));
  }

  function _updateScale(xDomain = d3.extent(_data, (d) => d.year)) {
    _updateScaleX(xDomain);
    _updateScaleY();
    _updateLine();
  }

  function _updateAxisX(t) {
    $gXAxis.attr('transform', `translate(0, ${h - margin.bottom})`);

    let $x = t ? $gXAxis.transition(t) : $gXAxis;
    $x.call(
      d3
        .axisBottom(X)
        .tickFormat((d) => (d <= d3.timeYear(d) ? d.getFullYear() : null))
    );

    $marks.update(t);

    return t;
  }

  function _updateAxisY(t) {
    $gYAxis.attr('transform', `translate(${w - margin.right}, 0)`);

    const $yAxisUnit = $gAxis
      .selectAll('text.y-unit')
      .data(['จำนวนพลาสติกสะสมรวม (ล้านตัน)'])
      .join('text')
      .attr('class', 'y-unit')
      .attr('x', margin.left)
      .attr('y', margin.top)
      .attr('dy', -4)
      .attr('dx', 50)
      .attr('font-size', 10)
      .attr('fill', 'black')
      .attr('opacity', 0)
      .transition(t)
      .attr('opacity', 1)
      .text((d) => d);

    // let $y = t ? $gYAxis.transition(t) : $gYAxis
    $gYAxis
      .call((g) => {
        let $y = t ? g.transition(t) : g;
        $y.call(d3.axisLeft(Y).tickSize(w - margin.left - margin.right));
      })
      .call((g) => g.select('.domain').remove())
      .call((g) =>
        g
          .selectAll('line')
          .attr('stroke-opacity', 0.5)
          .attr('stroke-dasharray', '2,2')
      )
      .call((g) =>
        g
          .selectAll('.tick text')
          .attr('dx', 40)
          .attr('dy', -4)
      );

    return t;
  }

  function _updateAxes(t) {
    _updateAxisX(t);
    _updateAxisY(t);

    // return for chaining transition
    return t;
  }

  function _updateCirclePosition($circle) {
    $circle.attr('cx', (d) => X(d.year)).attr('cy', (d) => Y(d.cpw));
  }

  function _timelineMark() {
    let $mark = $timelineContainer.selectAll('circle.mark');
    let data = [];

    const _export = {};

    _export.data = function(_data) {
      data = _data;
      _export.join();
    };

    _export.join = function(t) {
      $mark = $mark.data(data).join('circle');

      $mark
        .classed('mark', true)
        .attr('cy', Y(0))
        .attr('r', RADIUS)
        .attr('fill', 'black')
        .call(($) => {
          $ = t ? $.transition(t) : $;
          $.attr('cx', (d) => X(d));
        });
    };

    _export.append = function(year, t) {
      if (data.indexOf(year) === -1) data.push(year);
      else return;
      _export.join(t);
      $mark.filter((d) => d === year).attr('fill', 'green');
      $pulse
        .transition(t)
        .attr('cx', X(year))
        .attr('cy', Y(0));
    };

    _export.update = function(t) {
      $mark.call(($) => {
        $ = t ? $.transition(t) : $;
        $.attr('cx', (d) => X(d));
      });
    };

    _export.setCurrent = function(current) {
      // if (!arguments.length) $mark.attr('fill', 'black')
      $mark.attr('fill', (d) => (d === current ? 'green' : 'black'));
    };

    _export.handleYearChange = function(year) {
      data = [...data.slice(0, -1)];
      _export.append(new Date(year, 0, 0), d3.transition().duration(250));
    };

    _export.hide = function() {
      $gXAxis.attr('visibility', 'hidden');
      $mark.attr('visibility', 'hidden');
      $pulse.attr('visibility', 'hidden');
    };

    _export.show = function() {
      $gXAxis.attr('visibility', 'visible');
      $mark.attr('visibility', 'visible');
      $pulse.attr('visibility', 'visible');
    };

    return _export;
  }

  function _Img() {
    //   <clipPath id="clipCircle">
    //   <circle r="50" cx="50" cy="50" />
    // </clipPath>

    const IMG_DIM = { width: 260, height: 300 };
    IMG_DIM.ratio = IMG_DIM.width / IMG_DIM.height;
    const $img = $timelineContainer.select('image');
    const $line = $timelineContainer.select('line.img');
    const $clipCircle = $clipPath.select('circle');

    let show;

    const _export = {};

    _export.show = function() {
      if (show === true) return;
      const y1950 = X(new Date(1950, 0, 0));

      const height = Math.abs(Y(3000) - Y(0)),
        width = Math.abs(Y(3000) - Y(0)) * IMG_DIM.ratio;

      $clipCircle
        .attr('cx', y1950)
        .attr('cy', Y(3000))
        .attr('r', width / 2);

      $img
        .attr('x', y1950 - width / 2)
        .attr('y', Y(3000) - height / 2)
        .attr('height', height)
        .attr('width', width);

      $line
        .attr('x1', y1950)
        .attr('y1', Y(3000) - height / 2 + height / 2)
        .attr('x2', y1950)
        .attr('y2', Y(0))
        .attr('stroke-width', '2')
        .attr('stroke', 'black');

      show = true;
    };

    _export.hide = function() {
      [$img, $line].forEach(($) => $.remove());

      show = false;
    };

    return _export;
  }

  const STEP = {};

  STEP.plasticwaste1 = function({ reverse, leave }) {
    $img.show();
    const minYear = d3.min(data, (d) => d.year).getFullYear();
    _updateScale([new Date(minYear - 3, 1, 1), new Date(minYear + 1, 1, 1)]);
    _updateAxisX();
  };

  STEP.plasticwaste2 = function({ reverse, leave }) {
    $img.hide();
    $pulse.attr('visibility', 'hidden');
    $marks.setCurrent();
    if (!reverse && !leave) STEP.plasticwaste1({ leave: true });

    // incase of reverse back from plastic waste3 remove projection path
    if ($pathProjection) $pathProjection.call(resetline);

    _data = data.filter((d) => d.year <= new Date(2015, 1, 1));

    _updateScale();
    // draw line after axis transition end
    const t1 = d3.transition().duration(2500);
    const t2 = _updateAxes(t1)
      .transition()
      .duration(65 * 50)
      .ease(d3.easeLinear);
    const t3 = drawline(t2)
      .transition()
      .duration(200);
    drawcircle(t3);

    if (leave) {
      $pathcpw.interrupt();
      _updateAxes();
      drawline();
      drawcircle();
      $pulse.interrupt();
      $pulse.attr('visibility', 'hidden');
    }

    function drawcircle(t) {
      $circle = $lineContainer
        .selectAll('circle.y2015')
        .data(data.filter((d) => d.year.getFullYear() === 2015))
        .join('circle');

      $circle
        .attr('class', 'y2015')
        .call(_updateCirclePosition)
        .attr('fill', 'green')
        .attr('stroke', 'white')
        .attr('r', 0)
        .transition(t)
        .attr('r', RADIUS);

      $pulse
        .attr('cx', X(new Date(2015, 0, 0)))
        .attr('cy', Y(data.filter((d) => d.year.getFullYear() === 2015)[0].cpw))
        .transition(t)
        .attr('visibility', 'visible')
        .on('end', () =>
          $marks.data([new Date(1950, 0, 0), new Date(2015, 0, 0)])
        );

      if (!t) $marks.data([new Date(1950, 0, 0), new Date(2015, 0, 0)]);
    }

    function drawline(t) {
      $pathcpw = $lineContainer.select('path.cpw');
      $pathcpw
        .data([_data])
        .join('path')
        .attr('d', line)
        .attr('fill', 'transparent')
        .attr('stroke', 'black');

      const pathLen = $pathcpw.node().getTotalLength();

      $pathcpw.call(($) => {
        $.attr('stroke-dasharray', pathLen).attr('stroke-dashoffset', pathLen);
        $ = t ? $.transition(t) : $;

        $.attr('stroke-dashoffset', 0);
      });

      return t;
    }
  };

  function resetline($) {
    $.attr('d', null)
      .attr('fill', null)
      .attr('stroke', null)
      .attr('stroke-dasharry', null)
      .attr('stroke-dashoffset', null)
      .classed('marching-ant', false);
  }

  STEP.plasticwaste3 = function({ reverse, leave }) {
    if (!reverse && !leave) STEP.plasticwaste2({ leave: true });
    _data = data;

    $circle.attr('opacity', 0);
    // draw line after axis transition end
    _updateScale();
    const t = d3.transition().duration(1250);
    _updateAxes(t).on('end', _.once(updateAndDrawProjection));
    $pathcpw.transition(t).attr('d', line);

    function updateAndDrawProjection() {
      $pathProjection = $lineContainer.select('path.cpw-projection');
      $pathProjection
        .data([_data])
        .join('path')
        .attr('d', line)
        .attr('fill', 'transparent')
        .attr('stroke', 'black');

      const prevPathLen = $pathcpw.node().getTotalLength();
      const pathLen = $pathProjection.node().getTotalLength();

      const dashLen = 3;
      const dashCount = Math.ceil((pathLen - prevPathLen) / dashLen);
      const dashArray =
        prevPathLen +
        new Array(dashCount).join(' 3') +
        (dashCount % 2 === 0 ? ' 3' : '');

      $pathProjection
        .attr('stroke-dasharray', dashArray)
        .attr('stroke-dashoffset', pathLen - prevPathLen)
        .transition()
        .duration(35 * 50)
        .ease(d3.easeLinear)
        .attr('stroke-dashoffset', 0)
        .on(
          'end',
          _.once(() => {
            $pathProjection.classed('marching-ant', true);
            $circle = $circle
              .data(data.filter((d) => d.year.getFullYear() === 2050))
              .join('circle');

            $circle
              .attr('opacity', 1)
              .call(_updateCirclePosition)
              .attr('r', 0)
              .transition()
              .attr('r', RADIUS * 1.25);

            $pulse
              .attr('cx', X(new Date(2050, 0, 0)))
              .attr(
                'cy',
                Y(data.filter((d) => d.year.getFullYear() === 2050)[0].cpw)
              )
              .transition(t)
              .attr('visibility', 'visible')
              .on('end', () =>
                $marks.data([
                  new Date(1950, 0, 0),
                  new Date(2015, 0, 0),
                  new Date(2050, 0, 0),
                ])
              );
          })
        );
    }
    $lineContainer.attr('opacity', 1);
  };

  STEP.regulation1 = function() {
    $lineContainer
      .transition()
      .duration(500)
      .attr('opacity', 0);

    $marks.data([
      new Date(1950, 0, 0),
      new Date(2015, 0, 0),
      new Date(2050, 0, 0),
    ]);
    $marks.append(new Date(1970, 0, 0));
  };

  STEP.regulation2 = function() {
    $marks.data([
      new Date(1950, 0, 0),
      new Date(1970, 0, 0),
      new Date(2015, 0, 0),
      new Date(2050, 0, 0),
    ]);
    $marks.append(new Date(1994, 0, 0));
  };

  STEP.regulation3 = function() {
    $marks.show();
    $marks.data([
      new Date(1950, 0, 0),
      new Date(1970, 0, 0),
      new Date(2015, 0, 0),
      new Date(2050, 0, 0),
    ]);
    $marks.append(new Date(year, 0, 0));
  };

  STEP.regulation4 = function() {
    $marks.hide();
  };

  STEP.regulationBar = function() {};

  STEP.regulationSeperator = function() {
    $marks.hide();
  };

  STEP.regulationKenya = function() {
    $marks.show();
    $marks.handleYearChange(2017);
  };

  STEP.regulationHKG = function() {
    $marks.handleYearChange(2009);
  };

  STEP.regulationCHN = function() {
    $marks.handleYearChange(2008);
  };

  STEP.regulationAUT = function() {
    $marks.handleYearChange(2016);
  };

  STEP.regulationTHA = function() {
    $marks.handleYearChange(2020);
  };

  let _export = {};

  _export.handleStepChange = function(scrollEvent) {
    const { element, index, direction } = scrollEvent;
    step = d3.select(element).attr('data-step');
    if (typeof STEP[step] === 'function')
      STEP[step]({ reverse: direction === 'up' });
  };

  _export.resize = function() {
    if (typeof STEP[step] === 'function') STEP[step]({ leave: true });
  };

  _export.handleYearChange = function(_year) {
    year = _year;
    $marks.handleYearChange(year);
  };

  return _export;
}

export default D3Timeline;
